import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { ApiEnvelope } from 'src/@shared/auth';
import { AuthEndpoints } from 'src/@shared/endpoints/endpoints';

/** What PhoneChange/send and /resend return; `restart` means the user must tap Verify again. */
export interface PhoneChangeSendResult {
  challengeId?: string;
  maskedPhone?: string;
  restart: boolean;
  retryAfterSeconds: number;
}

export interface PhoneChangeVerifyResult {
  restart: boolean;
}

/** My Profile mobile-number change: the new number is only saved once a code texted to it is verified. */
@Injectable({ providedIn: 'root' })
export class PhoneChangeService {
  constructor(private _cS: CommonService) {}

  send(phoneNumber: string): Observable<ApiEnvelope<PhoneChangeSendResult>> {
    return this._cS.API_POST(AuthEndpoints.PhoneChangeSend, { phoneNumber }, false);
  }

  resend(challengeId: string): Observable<ApiEnvelope<PhoneChangeSendResult>> {
    return this._cS.API_POST(AuthEndpoints.PhoneChangeResend, { challengeId }, false);
  }

  verify(challengeId: string, code: string): Observable<ApiEnvelope<PhoneChangeVerifyResult>> {
    return this._cS.API_POST(AuthEndpoints.PhoneChangeVerify, { challengeId, code }, false);
  }
}
